import { localSettingsStore as e } from "./local-settings-store.js";
import { useStore as t } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { useShallow as n } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
//#region src/local-settings-store/useLocalSettingsStore.ts
var r = (r) => t(e, n(r));
//#endregion
export { r as useLocalSettingsStore };
